import lazySizes from 'lazysizes';

lazySizes.init();



// WEBPACK FOOTER //
// ./client/src/javascript/components/lazysizes.js